export const READ_MESSAGE_ACTION = 'read';
export const TIMETOKEN_DIVIDER = 10000;
